'use client';
import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 50vh;

  & > img {
    width: 100%;
    max-width: 300px;

    ${({ theme }) => theme.mediaQueries.LARGE_1X_UP} {
      max-width: 400px;
    }
  }

  & > h1 {
    font-size: 24px;
    font-weight: bold;
    margin-bottom: 0px;
    text-align: center;
    ${({ theme }) => theme.mediaQueries.LARGE_1X_UP} {
      font-size: 30px;
    }
  }

  & > p {
    margin-bottom: 0px;
    text-align: center;
  }

  & > a {
    margin-top: 1rem;
  }
`;

export const ButtonGroups = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-top: 1rem;
  gap: 0.5rem;
`;
